/* eslint-disable @typescript-eslint/no-explicit-any */

import { call, put } from 'redux-saga/effects'
import { MOCKED } from 'src/config'
import { error_t, opt, response_t, saga_act } from 'src/types'
import { sleep } from 'src/utils'

import { shoot } from '../actions'

/**
 * Do request
 */
export function* saga_do_request(
  service_call: (this: unknown, ...args: any[]) => any,
  action: saga_act
): unknown {
  yield put(shoot.reduce_loading(true, action?.type))

  if (MOCKED === 'true') {
    yield call(sleep, 1000)
  }

  let attempt = 0
  let error_: opt<error_t> = {}

  while (attempt < 1) {
    /**
     * Try service call
     */
    const { data, error }: response_t<unknown> = yield call(service_call, {
      ...action,
      args: {
        ...action.args,
      },
    })

    /**
     * Success
     */
    if (data) {
      yield put(shoot.reduce_loading(false, action?.type))
      return data
    }

    error_ = error
    attempt++
  }

  /**
   * Generic failure
   */
  yield put(shoot.reduce_error(error_))
  yield put(shoot.reduce_loading(false, action?.type))
  return undefined
}
